<div class = "body">
    <!-- 
    <div class ="container" style = "height:100px"> </div>
    <br/>
    -->
    <br/>
    <div class = "container principal">
        <div class="col-lg-12">
            <p>Circular N° 3623 de fecha 18.10.2021, Superintendencia de Seguridad Social. <b>Los afiliados deben conservar los
                    originales de los documentos </b>
                <br />
                <b>de respaldo de los beneficios solicitados digitalmente al Servicio de Bienestar, por el plazo de 5 años</b>
                <br />
                <b> conforme a los Artículos N° 2514 y 2515 del Código Civil.</b> Dictamen N° 467/2021.
                <br />
                <br />
                La adulteración de datos y/o documentos contables constituye una falta grave a la probidad lo cual
                <br />
                conlleva expulsión total del Servicio de Bienestar y el inicio inmediato de una investigación o sumario
                administrativo.
                <br />
            </p>
        
            <p><b>Manual de escolaridad: </b> <a href="{{this.linkTexto}}" target="_blank">
                Escolaridad</a>.</p>
        </div>
    </div>
    <br/>
    <div class = "container principal">
        
        <div *ngIf = "rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class = "row">
                
                <div class = "col-lg-8"> </div>
                
                <div class = "col-lg-4"> <p> <b> Usuario: </b> {{nombreUsuario}} </p> </div>
                 
            </div>

        </div>
        
        <div *ngIf = "rol != 'ROLE_AFILIADO'" style = "padding-bottom: 20px;">
            
            <div class = "row">
                
                <div class = "col-lg-1"> </div>

                <div class = "col-lg-2"> <h1> Rut Afiliado </h1> </div>

                <div class = "col-lg-6"> 
                    
                    <input id = "txt_rut" name = "afiliado" [(ngModel)] = "escolaridad.afiliado" 
                    #afiliado = "ngModel" class = "form-control" type = "text" required 
                    placeholder = "Ingrese el RUT del afiliado. Ej: 11111111-1" pattern = "[0-9.]{7,10}[-]{1}[0-9Kk]{1}" /> 
                
                </div>

                <div class = "col-lg-1"> </div>

                <div class = "col-lg-1"> 
                    
                    <button class = "btn btn-primary" id = "btnvalida" (click) = "ingresaAfiliado()" [disabled] = "afiliado.invalid"> 
                        
                        Buscar 
                    
                    </button> 
                
                </div>

                <div class = "col-lg-1"> </div>

            </div>

        </div>

        <div class = "row">
  
            <div class = "col-lg-1"> </div>
            
            <div class = "col-lg-4"> <h1> Subsidio Escolaridad </h1> </div>

            <div class = "col-lg-4"> </div>
  
        </div>
        
        <hr/> <br/>

        <form #escolaridadForm = ngForm >

            <div class = "table-responsive">

                <table class = "table">
                
                    <thead style = "background-color: #0f69b4;color:white;">
                    
                        <tr>
                            <th scope = "col"> Rut </th>

                            <th scope = "col"> Nombre y Apellido </th>

                            <th scope = "col"> Parentesco </th>
                            
                            <th scope = "col"> Edad </th>
                            
                            <th scope = "col"> Sexo </th>

                            <th scope = "col"> Seleccionar </th>
                        </tr>

                    </thead>
                    
                    <tbody>
                        
                        <tr class = "tablaPostulantes" *ngFor = "let postulante of postulantes; let i = index">
                            
                            <td> {{postulante.rut + '-' + postulante.dv}} </td>

                            <td> {{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                            <td> {{postulante.parentesco}} </td>

                            <td>  {{postulante.fechaNacimiento}} </td>
                    
                            <td> {{postulante.sexo.nombre}} </td>

                            <td> 

                                <input type = "radio" name = "postulante" [(ngModel)] = "escolaridad.beneficiario" 
                                value = "{{postulante.rut + '-' + postulante.id + '-' + postulante.parentesco}}" 
                                required (click) = "beneficiarioEtapaEscolar(postulante.parentesco)"> 
                            
                            </td> 
                
                        </tr>

                    </tbody>

                </table>

            </div> <br/> <br/>            

            <div class = "row">
                
                <div class = "col-lg-1 col-xs-1"> </div>

                <div class = "col-lg-3 col-xs-5"> <h2> Otros Datos </h2> </div>
                
                <div class = "col-lg-1 col-xs-5"> </div>
            
            </div> <br/>
            
            <div class = "row">
                
                <div class = "col-lg-1"> </div>

                <div class = "col-lg-2"> <label> Etapa Escolar </label> </div>
                
                <div class = "col-lg-8">
                    
                    <div class = "form-group"> 

                        <select name = "curso" class = "form-control" required 
                        [(ngModel)] = "escolaridad.etapaEscolar" #curso = "ngModel">
                        
                            <option *ngFor = "let curso of cursos" value = "{{curso}}"> 
                                
                                {{curso}} 
                            
                            </option>

                        </select>

                    </div>   
                    
                    <div *ngIf = "curso.errors && curso.touched" class = "alert alert-danger">

                        <div *ngIf = "curso.errors.required"> Seleccione Etapa Escolar. </div>

                    </div>
                
                </div>
    
            </div> <br/>

            <div class = "row line">
                
                <div class = "col-lg-1"> </div>

                <div class = "col-lg-2"> <p> Fecha Certificado </p> </div>
                
                <div class = "col-lg-5">

                    <input class = "form-control" name = "diagnostico" required #diagnostico = "ngModel"
                    [(ngModel)] = "escolaridad.fechaCertificado" type = "date">

                </div>

                <div class = "col-lg-4"> </div>

            </div>

            <div class = "row line">
                
                <div class = "col-lg-1"> </div>

                <div class = "col-lg-2"> <p> Adjuntar </p> </div>
                
                <div class = "col-lg-5">

                    <input #archivo [(ngModel)] = "escolaridad.archivoTest" type = "file" class = "form-control-file" 
                    name = "archivo" (change) = "seleccionaArchivo($event)" required
                    accept = "application/pdf, image/jpeg, image/jpg, image/png" >
                
                </div>

                <div class = "col-lg-4"> </div> <br/> <br/>

            </div>

            <div class = "row line">
                
                <div class = "col-lg-2 col-sm-2"> </div>

                <div class = "col-lg-6 col-sm-1"> <button class = "btn btn-danger" (click) = "salir()"> Salir </button> </div>

                <div class = "col-lg-3 col-sm-1">
                    <div *ngIf = "rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_CONTABILIDAD' && rol != 'ROLE_ENCARGADO_CONTABILIDAD'">
                        <button class = "btn btn-success" (click) = "solicitar(escolaridadForm)" [disabled] = "escolaridadForm.invalid"> 
                            
                            Solicitar
                        
                        </button>
                    </div>
                </div>
                
                <div class = "col-lg-1 col-sm-1"> </div>
            
            </div>            
        
        </form>

    </div>

    <div class = "container" style = "height:100px"> </div>

  </div>
